<template>
	<div>
		<el-row :gutter="0">
                <el-col :span="4">
                     <el-button size="small" type="primary" @click="addColumn()">新增栏目</el-button>
                    <div class="ibox-content" :style="constyle">
                        <el-tree :data="data2" node-key="id" :props="defaultProps" @node-click="handleNodeClick"
                            v-loading="loading" :highlight-current="isshow" :default-expanded-keys="openkeys"
                            :default-expand-all="closed" :show-checkbox='show_checkboxd' ref="tree2" class="listtree">
                        </el-tree>
                    </div>
                </el-col>
                <el-col :span="18">
                    <div class="ibox-content b-l">
                        <h5>栏目主要资料</h5>
                        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px"
                            class="demo-ruleForm">
                            <el-form-item label="上级栏目">
                                <el-cascader placeholder="请选择" v-model="ruleForm.mid" :options="hospital_options" filterable
                                     :props="{ value: 'id', label: 'cate_name' ,children :'child'  ,checkStrictly: true }" size='small' clearable></el-cascader>
                            </el-form-item>
                            <el-form-item label="栏目名称" prop="title">
                                <el-input size="small" v-model="ruleForm.title"></el-input>
                            </el-form-item>
                            <el-form-item label="英文名称">
                                <el-input size="small" v-model="ruleForm.englistitle"></el-input>
                            </el-form-item>
                            <el-form-item label="栏目目录">
                                <el-input size="small" v-model="ruleForm.cate_folder"></el-input>
                            </el-form-item>
                            
                            <el-form-item label="外部链接">
                                <el-input size="small" v-model="ruleForm.url"></el-input>
                            </el-form-item>
                            <el-form-item label="栏目图片">
			                     <div>
				             <span v-if="!ruleForm.image" class="btn btn-light border mr-2"
				             @click="chooseImages">
					          <i class="el-icon-plus"></i>
				                  </span>
				            <img v-else :src="ruleForm.image" class="rounded" style="width: 100px;height: 100px;cursor: pointer;" @click="chooseImages"/>
			                   </div>
		                    </el-form-item>
                            <el-form-item label="ICO图片">
			                     <div>
				             <span v-if="!ruleForm.ico_image" class="btn btn-light border mr-2"
				             @click="chooseImage">
					          <i class="el-icon-plus"></i>
				                  </span>
				            <img v-else :src="ruleForm.ico_image" class="rounded" style="width: 100px;height: 100px;cursor: pointer;" @click="chooseImage"/>
			                   </div>
		                    </el-form-item>
                            <el-form-item label="关键字">
                                <el-input size="small" v-model="ruleForm.keywords"></el-input>
                            </el-form-item>
                             <el-form-item label="描述">
                                <el-input size="small" v-model="ruleForm.description"></el-input>
                            </el-form-item>
                            <el-form-item label="内容">
                              <WangEditor  ref="editor1" @editorContent="changeEditor" :editorContent="ruleForm.editorContent" :operateflag="ruleForm.operateflag"/>
                             </el-form-item>
                            <el-form-item label="排序值" prop="sort">
                                <el-input size="small" v-model="ruleForm.sort"></el-input>
                            </el-form-item>
                            <el-form-item label="是否启用" prop="type">
                                <el-radio v-model="ruleForm.radio" label='1'>是</el-radio>
                                <el-radio v-model="ruleForm.radio" label='2'>否</el-radio>
                            </el-form-item>
                            <el-form-item>
                                <el-button size="small" type="primary" @click="submitForm('ruleForm')">提交资料</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                </el-col>
            </el-row>
	</div>
</template>

<script>
const WangEditor = () => import('@/components/wangEnduit/index')
	export default {
		inject:['app','layout'],
        components: {
            WangEditor,
		},
		data() {
			return {
                hospital_options:[],
                data2:[],
                defaultProps: {
                    children: 'child',
                    label: 'cate_name'
                },
                isshow: false,
                openkeys: [],
                 closed: false,
                 show_checkboxd: false,
                loading: false,
                 constyle: {
                    height: window.innerHeight - 150 + "px",
                    'overflow-y': 'scroll'
                },
                 ruleForm: {
                     options: [],
                     mid:'',
                    title:'',
                    englistitle:'',
                    cate_folder:'',
                    parent_id:'',
                    url:'',
                    image:'',
                    ico_image:'',
                    keywords:'',
                    description:'',
                    sort:'',
                    radio:'2',
                    editorContent:'',
                    operateflag:"add",
                },
                 rules: {
                    title: [{
                        required: true,
                        message: '栏目名称不能为空',
                        trigger: 'blur'
                    }]
                },
                add_fa: false,
                ids:'',
                // 判断栏目是新增还是编辑
                columnFlag:"add",
                eid:'',
			}
		},
		created(){
		},
        mounted(){
            this.getlm()
        },
		methods: {
            getlm(){
                 let that = this
                 that.loading = true
                axios 
                    .post("/admin/lgTpCate/index", {
                    },{
                        token:true
                    })
                    .then(response => {
                       that.data2 = response.data.data
                       that.loading = false
                       that.hospital_options = response.data.data
                    })
                    .catch(error => {})
            },
			handleNodeClick(data){
                let that = this
                that.ruleForm.operateflag = "edit";
                that.eid = data.id
                that.ruleForm.editorContent = data.content?data.content:'';
                that.ruleForm.mid = data.parent_id
                that.ruleForm.title = data.cate_name
                that.ruleForm.englistitle = data.en_name
                that.ruleForm.cate_folder = data.cate_folder
                that.ruleForm.url = data.url
                that.ruleForm.image = data.image
                that.ruleForm.ico_image = data.ico_image
                that.ruleForm.keywords = data.keywords
                that.ruleForm.description = data.description
                that.ruleForm.sort = data.sort
                that.ruleForm.radio = data.status.toString()
                // 栏目编辑标志
                that.columnFlag = "edit";

            },
            add_sonlist(){},
            del_list(){},
            chooseImage(){
                this.app.chooseImage((res)=>{
					this.ruleForm.ico_image = res[0].url
				},1)
            },
            chooseImages(){
                this.app.chooseImage((res)=>{
					this.ruleForm.image = res[0].url
				},1)
            },
            submitForm(){
                let that = this
                 that.loading = true
                 if(that.columnFlag=="add"){
                      axios 
                    .post("/admin/lgTpCate/Madd", {
                        content:that.ruleForm.editorContent,
                        cate_name:that.ruleForm.title,
                        en_name:that.ruleForm.englistitle,
                        cate_folder:that.ruleForm.cate_folder,
                        parent_id:that.ruleForm.mid,
                        url:that.ruleForm.url,
                        image:that.ruleForm.image,
                        ico_image:that.ruleForm.ico_image,
                        keywords:that.ruleForm.keywords,
                        description:that.ruleForm.description,
                        status: that.ruleForm.radio,
                        sort:that.ruleForm.sort,
                        // id:that.columnFlag=="add"?0:that.eid

                    },{
                        token:true
                    })
                    .then(response => {
                       if (response.data.code == 200) {
                        this.$message({
                            showClose: true,
                            type: 'success',
                            message: response.data.msg

                        });
                        that.getlm()
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.data.msg,
                            type: 'error'
                        });
                    }
                        })
                        .catch(error => {})
                 }
                 if(that.columnFlag=="edit"){
                      axios 
                    .post("/admin/lgTpCate/Medit", {
                        content:that.ruleForm.editorContent,
                        cate_name:that.ruleForm.title,
                        en_name:that.ruleForm.englistitle,
                        cate_folder:that.ruleForm.cate_folder,
                        parent_id:that.ruleForm.mid,
                        url:that.ruleForm.url,
                        image:that.ruleForm.image,
                        ico_image:that.ruleForm.ico_image,
                        keywords:that.ruleForm.keywords,
                        description:that.ruleForm.description,
                        status: that.ruleForm.radio,
                        sort:that.ruleForm.sort,
                        id:that.eid

                    },{
                        token:true
                    })
                    .then(response => {
                       if (response.data.code == 200) {
                        this.$message({
                            showClose: true,
                            type: 'success',
                            message: response.data.msg

                        });
                        that.getlm()
                    } else {
                        this.$message({
                            showClose: true,
                            message: response.data.msg,
                            type: 'error'
                        });
                    }
                        })
                        .catch(error => {})
                 }
               
                    
            },
            addColumn(){
                let that = this;
                that.ruleForm.operateflag = "add";
                that.columnFlag = "add";
                 that.ruleForm.editorContent ='';
                that.ruleForm.mid = ''
                that.ruleForm.title = ''
                that.ruleForm.englistitle = ''
                that.ruleForm.cate_folder = ''
                that.ruleForm.url = ''
                that.ruleForm.image = ''
                that.ruleForm.ico_image = ''
                that.ruleForm.keywords = ''
                that.ruleForm.description = ''
                that.ruleForm.sort = ''
                that.ruleForm.radio = ''
            },
             changeEditor(param){
console.log("asd",param)
let that = this
that.ruleForm.editorContent = param;
            }
		},
	}
</script>

<style>
</style>
